/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
    'use strict';
    var Hogan = algolia.externals.Hogan;
    var now_date = Date.now();

    var formatPrice = function formatPrice(value) {
        return algolia.formatMoney(Number(value) * 100);
    };

    function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
        var comparing =
            Number(compare_at_price) && Number(compare_at_price) > Number(price);
        var discount_ratio = 1.0 - price_ratio;
        var res = '<span>' + formatPrice(price) + '</span>';
        if (comparing) {
            res +=
                ' <span class="ais-hit--price-striked"><span>' +
                formatPrice(compare_at_price) +
                '</span></span> ';
        }

        return res;
    }

    function percentageOff(price, compare_at_price, price_ratio) {
        var percentage = 0;

        if (price === null) {
            percentage = Math.round((1 - price_ratio) * 100);
        } else {
            percentage = Math.round((1 - (price / compare_at_price)) * 100)
        }

        return ' <span class="ais-hit--price-discount">' +
            percentage +
            '% off</span>';
    }

    var escapeHtml = function escapeHtml(unsafe) {
        return (unsafe || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    algolia.helpers = {
        formatNumber: function formatNumber(text, render) {
            return Number(render(text)).toLocaleString();
        },
        formattedPrice: function formattedPrice(text, render) {
            return formatPrice(render(text));
        },
        soldOutTag: function soldOutTag() {
            return '<span class="product-price__item price-label price-label--sold-out">Sold Out</span>';
        },
        customLabel1: function customLabel() {
            const custom_label_1 = this.meta.theme;

            if (custom_label_1) {
                const entries = Object.entries(custom_label_1);
                const label = entries.map(([key, value]) => {
                    if (key === "label") {
                        return value;
                    }
                }).filter(val => val !== undefined);
                const custom_label_1_val = Object.values(custom_label_1);
                return `<span class="product-label product-label-custom-1"><span>${label}</span></span>`;
            }
        },
        customLabel2: function customLabel() {
            const custom_label_2 = this.meta.theme;

            if (custom_label_2) {
                const entries = Object.entries(custom_label_2);
                const label = entries.map(([key, value]) => {
                    if (key === "label_2") {
                        return value;
                    }
                }).filter(val => val !== undefined);
                const custom_label_1_val = Object.values(custom_label_2);
                return `<span class="product-label product-label-custom-2"><span>${label}</span></span>`;
            }
        },
        customLabel3: function customLabel() {
            const custom_label_3 = this.meta.theme;

            if (custom_label_3) {
                const entries = Object.entries(custom_label_3);
                const label = entries.map(([key, value]) => {
                    if (key === "label_3") {
                        return value;
                    }
                }).filter(val => val !== undefined);
                const custom_label_1_val = Object.values(custom_label_3);
                return `<span class="product-label product-label-custom-3"><span>${label}</span></span>`;
            }
        },
        imageLabel: function imageLabel() {
            const published_date = Date.parse(this.published_at);
            const diff_in_m_secs = now_date - published_date;
            const diff_in_days = Math.floor(diff_in_m_secs / (1000 * 60 * 60 * 24));
            const new_in_limit = window.settings_prod_new_limit_int;
            const show_new_in_label = window.settings_show_new_in_label === 'true' ? true : false;
            const new_in_method = window.settings_new_in_method;
            const has_new_in_tag = this.tags.indexOf('New') > -1 || false;
            const new_in_label = '<span style="color: #808284">New in</span>';

            if (this.isOnSale) {
                return percentageOff(this.variants_min_price, this.compare_at_price, this.price_ratio);
            }

            if (show_new_in_label) {
                if (new_in_method === 'collection') {
                    if (this.isNewIn() === 'new-arrivals') {
                        return '<span>New in</span>';
                    }
                }
                if (new_in_method === 'tag') {
                    if(has_new_in_tag) {
                        return new_in_label;
                    }
                }
                if (new_in_method === 'date') {
                    if ( diff_in_days < new_in_limit) {
                        return new_in_label;
                    }
                }
            }
        },
        formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
            text,
            render
        ) {
            return formatPrice(render(text)).replace(/\.\d+$/, '');
        },
        autocompletePrice: function autocompletePrice() {
            if (this._distinct) {
                var min = this.variants_min_price;
                var max = this.variants_max_price;
                if (min !== max) {
                    return '<span>' + formatPrice(min) + ' - ' + formatPrice(max) + '</span>';
                }
            }
            return formattedPriceWithComparison(this.price, null);
        },
        instantsearchPrice: function instantsearchPrice() {
            if (this._distinct) {
                var min = this.variants_min_price;
                var max = this.variants_max_price;
                if (min !== max) {
                    var res = '<span class="product-price__item product-price__from">From</span><span>' + formatPrice(min) + '</span>';

                    if (this.isOnSale) {
                        res +=
                            ' <span class="ais-hit--price-striked"><span>' +
                            formatPrice(this.compare_at_price) +
                            '</span></span> ';
                    }

                    return res;
                }
            }

            return formattedPriceWithComparison(
                this.price,
                this.compare_at_price,
                this.price_ratio
            );
        },
        instantsearchLink: function instantsearchLink() {
            var addVariantId = !this._distinct && this.objectID !== this.id;
            return (
                '/products/' +
                this.handle +
                (addVariantId ? '?variant=' + this.objectID : '')
            );
        },
        fullTitle: function fullTitle() {
            var res = this.title;
            if (
                !this._distinct &&
                this.variant_title &&
                this.variant_title !== 'Default Title' &&
                this.variant_title !== 'Default'
            ) {
                res += ' (' + this.variant_title + ')';
            }

            return escapeHtml(res);
        },
        fullHTMLTitle: function fullHTMLTitle() {
            var res = '';

            if (this._highlightResult.title && this._highlightResult.title.value) {
                res = algolia.helpers.fullEscapedAttribute(
                    this._highlightResult.title.value
                );
            }

            if (
                !this._distinct &&
                this.variant_title &&
                this.variant_title !== 'Default Title' &&
                this.variant_title !== 'Default'
            ) {
                res += ' <span class="algolia-variant">(' + res + ')</span>';
            }
            return res;
        },
        fullEscapedAttribute(attribute) {
            return new DOMParser().parseFromString(attribute, 'text/html')
                .documentElement.textContent;
        },
        fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
            var res = '';

            if (this._highlightResult.title && this._highlightResult.title.value) {
                res = algolia.helpers.fullEscapedAttribute(
                    this._highlightResult.title.value
                );
            }

            if (
                !this._distinct &&
                this.variant_title &&
                this.variant_title !== 'Default Title' &&
                this.variant_title !== 'Default'
            ) {
                res += ' <span class="algolia-variant">(' + res + ')</span>';
            }
            return res;
        },
        fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
            if (
                this._highlightResult.product_type &&
                this._highlightResult.product_type.value
            ) {
                return algolia.helpers.fullEscapedAttribute(
                    this._highlightResult.product_type.value
                );
            } else {
                return '';
            }
        },
        fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
            if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
                return algolia.helpers.fullEscapedAttribute(
                    this._highlightResult.vendor.value
                );
            } else {
                return '';
            }
        },
        floor: function floor(text, render) {
            return '' + Math.floor(Number(render(text)));
        },
        ceil: function ceil(text, render) {
            return '' + Math.ceil(Number(render(text)));
        },
        sizedImage: function sizedImage(text, render) {
            var image = this._distinct ? this.product_image : this.image;
            if (!image) {
                return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
            }
            var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
            if (size === 'original') {
                return image;
            }
            return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
        },
    };

    [
        'pico',
        'icon',
        'thumb',
        'small',
        'compact',
        'medium',
        'large',
        'grande',
        'original',
    ].forEach(function (size) {
        algolia.helpers[size + 'Image'] = (function (_size) {
            return function () {
                var image = this._distinct ? this.product_image : this.image;

                if (!image) {
                    return 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';
                }

                if (_size === 'original') {
                    return image;
                }

                return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
            };
        })(size); // We need to create a new scope so that the internal size has the good value.
    });

    /* Create an Hogan lambda, which doesn't respect the mustache doc */
    var helpers = algolia.assign(
        {},
        algolia.helpers,
        algolia.translation_helpers
    );
    var helpersNames = Object.keys(helpers);
    var i = helpersNames.length;
    var helpersArray = new Array(i);
    while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

    algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
        var name = options[0];
        var helper = options[1];

        var newRes = algolia.assign({}, res);

        newRes[name] = function () {
            return function (text) {
                var render = function (value) {
                    return Hogan.compile(value, algolia.hoganOptions).render(this);
                }.bind(this);

                return helper.call(this, text, render);
            }.bind(this);
        };

        return newRes;
    }, {});
})(window.algoliaShopify);
